import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var kvkkService = {

    kvkkListe(baslangic, limit, durum) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                serviceName: "kvkk",
                methodName: "kvkkListe"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kvkkTamamlanmamis() {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                serviceName: "kvkk",
                methodName: "kvkkTamamlanmamis"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kvkkCount(durum) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                durum: durum,
                serviceName: "kvkk",
                methodName: "kvkkCount"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kvkkSearch(key) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                key: key,
                serviceName: "kvkk",
                methodName: "kvkkArama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kvkkOnay(hastaId, dogrulamaKodu) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                hastaId: hastaId,
                dogrulamaKodu: dogrulamaKodu,
                serviceName: "kvkk",
                methodName: "kvkkOnay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    kvkkOnayTelefon(telefon,hastaId, dogrulamaKodu) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                kategori: userData3H["kategori"],
                telefon: telefon,
                hastaId: hastaId,
                dogrulamaKodu: dogrulamaKodu,
                serviceName: "kvkk",
                methodName: "kvkkOnayTelefon"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    kvkkKodGonder(telefon,hastaId, kategori) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                telefon: telefon,
                hastaId: hastaId,
                kategori: kategori,
                serviceName: "kvkk",
                methodName: "kvkkKodGonder"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    kvkkKod(telefon) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                kategori: userData3H["kategori"],
                telefon: telefon,
                serviceName: "kvkk",
                methodName: "kvkkKod"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

}

export default kvkkService
